export enum CoverageDisplayEnum {
    Future = 'future',
    Current = 'current'
}
